module.exports = __webpack_public_path__ + "static/media/fileIcon.1a066b71.svg";